"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("../..");
var _SourcePropType = _interopRequireDefault(require("../SourcePropType"));
var _Permissions = require("../../constants/Permissions");
var _Permission = _interopRequireDefault(require("../Permissions/Permission"));
var _SourceListItemFocusMenu = require("./SourceListItemFocusMenu.styled");
var _SourceListItemCtaIcons = _interopRequireDefault(require("./SourceListItemCtaIcons"));
var _SourceItemBodyMidSection = _interopRequireDefault(require("./SourceItemBodyMidSection"));
var _SourceItemBodyBottomSection = _interopRequireDefault(require("./SourceItemBodyBottomSection"));
var _broadcastSourceHelper = require("../../utils/broadcastSourceHelper");
var _this = void 0;
var getViewPermissions = function getViewPermissions() {
  return [_Permissions.MULTI_SELECT];
};
var SourceListItemFocusMenu = function SourceListItemFocusMenu(_ref) {
  var hovered = _ref.hovered,
    source = _ref.source,
    onFeaturedToggleClicked = _ref.onFeaturedToggleClicked,
    onMuteToggleClicked = _ref.onMuteToggleClicked,
    loop = _ref.loop,
    onLoopToggleClicked = _ref.onLoopToggleClicked,
    onCameraToggleClicked = _ref.onCameraToggleClicked,
    isCameraOn = _ref.isCameraOn,
    isMaximumCameraSourcesOn = _ref.isMaximumCameraSourcesOn,
    live = _ref.live,
    isStaged = _ref.isStaged,
    onLiveToggleClicked = _ref.onLiveToggleClicked,
    onSourceStaged = _ref.onSourceStaged,
    attendeeReceivedFrame = _ref.attendeeReceivedFrame,
    onVolumeChanged = _ref.onVolumeChanged,
    onSourceSetToLive = _ref.onSourceSetToLive,
    isStagedSourcesActive = _ref.isStagedSourcesActive,
    isTooltipVisible = _ref.isTooltipVisible,
    toggleTooltipVisibilityOn = _ref.toggleTooltipVisibilityOn,
    user = _ref.user,
    viewPermissions = _ref.viewPermissions,
    onPdfAssignClicked = _ref.onPdfAssignClicked,
    layout = _ref.layout;
  var type = source.type,
    _id = source._id,
    featured = source.featured,
    value = source.value,
    muted = source.muted;
  var isAudioSource = type === _.AUDIO_FILE;
  var displayComponent = function displayComponent(enableFeature) {
    return /*#__PURE__*/_react["default"].createElement(_SourceListItemFocusMenu.SourceListItemFocusMenuWrapper, {
      $isHovered: hovered
    }, /*#__PURE__*/_react["default"].createElement(_SourceListItemFocusMenu.SourceListItemCtaIconsWrapper, null, enableFeature && /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons["default"], {
      hovered: hovered,
      source: source,
      sourceType: type,
      featured: featured,
      onFeaturedToggleClicked: onFeaturedToggleClicked,
      muted: (0, _broadcastSourceHelper.isPresenterSource)(source) ? muted : value.muted,
      onMuteToggleClicked: onMuteToggleClicked,
      loop: loop,
      onLoopToggleClicked: onLoopToggleClicked,
      sourceId: _id,
      onCameraToggleClicked: onCameraToggleClicked,
      isCameraOn: isCameraOn,
      isMaximumCameraSourcesOn: isMaximumCameraSourcesOn,
      onSourceSetToLive: onSourceSetToLive,
      isStagedSourcesActive: isStagedSourcesActive,
      isTooltipVisible: isTooltipVisible,
      toggleTooltipVisibilityOn: toggleTooltipVisibilityOn,
      user: user,
      viewPermissions: viewPermissions,
      layout: layout,
      live: live
    })), /*#__PURE__*/_react["default"].createElement(_SourceItemBodyMidSection["default"], {
      hovered: hovered,
      live: live,
      enableFeature: enableFeature,
      isStaged: isStaged,
      onLiveToggleClicked: onLiveToggleClicked,
      isStagedSourcesActive: isStagedSourcesActive,
      isMaximumCameraSourcesOn: isMaximumCameraSourcesOn,
      sourceId: source._id,
      isCameraOn: isCameraOn,
      sourceType: type
    }), /*#__PURE__*/_react["default"].createElement(_SourceItemBodyBottomSection["default"], {
      hovered: hovered,
      source: source,
      onSourceStaged: onSourceStaged,
      enableFeature: enableFeature,
      isStaged: isStaged,
      attendeeReceivedFrame: attendeeReceivedFrame,
      onVolumeChanged: onVolumeChanged,
      isAudioSource: isAudioSource,
      live: live,
      toggleTooltipVisibilityOn: toggleTooltipVisibilityOn,
      user: user,
      viewPermissions: viewPermissions,
      onPdfAssignClicked: onPdfAssignClicked
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_Permission["default"], {
    permissions: getViewPermissions(),
    protectedComponent: displayComponent.bind(_this),
    user: user,
    viewPermissions: viewPermissions
  });
};
SourceListItemFocusMenu.propTypes = {
  source: _SourcePropType["default"],
  onFeaturedToggleClicked: _propTypes["default"].func,
  onMuteToggleClicked: _propTypes["default"].func,
  loop: _propTypes["default"].bool,
  onLoopToggleClicked: _propTypes["default"].func,
  onCameraToggleClicked: _propTypes["default"].func,
  isCameraOn: _propTypes["default"].bool,
  isMaximumCameraSourcesOn: _propTypes["default"].bool,
  live: _propTypes["default"].bool,
  isStaged: _propTypes["default"].bool,
  onLiveToggleClicked: _propTypes["default"].func,
  onSourceStaged: _propTypes["default"].func,
  attendeeReceivedFrame: _propTypes["default"].object,
  onVolumeChanged: _propTypes["default"].func,
  onSourceSetToLive: _propTypes["default"].func,
  hovered: _propTypes["default"].bool,
  isStagedSourcesActive: _propTypes["default"].bool,
  isTooltipVisible: _propTypes["default"].bool,
  toggleTooltipVisibilityOn: _propTypes["default"].func,
  user: _propTypes["default"].object,
  viewPermissions: _propTypes["default"].object,
  onPdfAssignClicked: _propTypes["default"].func
};
var _default = exports["default"] = SourceListItemFocusMenu;